import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useSettings } from '../context/SettingsContext';
import useScrollReveal from '../hooks/useScrollReveal';
import QuoteForm from '../components/QuoteForm';

function Contact() {
  const { settings } = useSettings();
  useScrollReveal();

  return (
    <>
      <Helmet>
        <title>İletişim | {settings.site_title || ''}</title>
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>İletişim</h1>
          <div className="breadcrumb">
            <Link to="/">Ana Sayfa</Link>
            <span>/</span>
            <span>İletişim</span>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="contact-grid reveal">
            {/* Contact Info */}
            <div className="contact-info">
              <h2>İletişim Bilgileri</h2>

              {settings.phone && (
                <div className="contact-info-item">
                  <div className="contact-info-icon"><FaPhone /></div>
                  <div>
                    <strong>Telefon</strong>
                    <p>{settings.phone}</p>
                  </div>
                </div>
              )}

              {settings.email && (
                <div className="contact-info-item">
                  <div className="contact-info-icon"><FaEnvelope /></div>
                  <div>
                    <strong>E-posta</strong>
                    <p>{settings.email}</p>
                  </div>
                </div>
              )}

              {settings.address && (
                <div className="contact-info-item">
                  <div className="contact-info-icon"><FaMapMarkerAlt /></div>
                  <div>
                    <strong>Adres</strong>
                    <p>{settings.address}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Teklif Formu */}
          <div style={{ marginTop: '2rem' }}>
            <QuoteForm />
          </div>

          {/* Google Maps Embed */}
          {settings.maps_embed && (
            <div style={{ marginTop: '2rem' }}>
              <iframe
                src={settings.maps_embed}
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Harita"
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Contact;
